export default {
  html: {
    padding: '10px 0',
  },
}
